/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import Toggle from 'Hoc/ToggleComponent'

import './DeleteCartItemModal.scss'

const DeleteCartItemModal = (props) => (
  <Toggle>
    <MerchantModal
      title={props.title}
      onClose={props.onClose}
      primaryButtonLabel={props.primaryButtonLabel}
      secondaryButtonLabel={props.secondaryButtonLabel}
      secondaryAction={props.secondaryAction}
      primaryAction={props.primaryAction}
      disableBackdropClick
    >
      {props.product &&
        <MerchantGenericCard>
          <div className='posProductImgBox'>
            <img
              className='posProductImg'
              src={props.product.image}
              alt={props.product.altTextImg}
            />
          </div>
          <div className='posProductContent'>
            <div className='posProductHeaderRow'>
              <div className='posProductHeader'>
                <h1 className='posProductTitle'>
                  {props.product.productName}
                </h1>
                <h2 className='posProductSubtitle'>
                  {props.product.productModel}
                </h2>
              </div>
            </div>
          </div>
        </MerchantGenericCard>}
    </MerchantModal>
  </Toggle>
)

DeleteCartItemModal.propTypes = {
  product: PropTypes.shape({
    productName: PropTypes.string,
    productModel: PropTypes.string,
    image: PropTypes.string,
    altTextImg: PropTypes.string
  }).isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondaryAction: PropTypes.func,
  primaryAction: PropTypes.func,
  onClose: PropTypes.func
}

DeleteCartItemModal.defaultProps = {
  product: {},
  title: '',
  primaryButtonLabel: '',
  secondaryButtonLabel: '',
  secondaryAction: () => { },
  primaryAction: () => { },
  onClose: undefined
}

export default DeleteCartItemModal
